// extracted by mini-css-extract-plugin
export default {"fr-view":"QuestionTitleEditor_fr-view__HpbWY","title-input":"QuestionTitleEditor_title-input__x03ef"};